import {useState} from "react";
import {Button, Col, Form, Row} from "react-bootstrap";
import {Choose} from "./components";
import styles from "./index.module.scss";
import {useAppDispatch, useAppSelector} from "../../../redux/hooks";
import {
    getBody,
    getBodyAdd,
    getCarStateAdd,
    getEnginesAdd,
    getGenerationAdd,
    getModelsAdd
} from "../../../redux/selectors";
import {getBodies, getCar, getEngine, getGenerations, getModel} from "../../../redux/reducers";

const AddProduct = () => {
    const [step, setStep] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const cars = useAppSelector((state) => getCarStateAdd(state));
    const models = useAppSelector((state) => getModelsAdd(state));
    const engine = useAppSelector((state) => getEnginesAdd(state));
    const body = useAppSelector((state) => getBodyAdd(state));
    const generation = useAppSelector((state) => getGenerationAdd(state));

    const dispatch = useAppDispatch();
    console.log(models)
    const getModelAddFunc = (val: string) => {
        // @ts-ignore
        dispatch(getCar(val))
        console.log(val)
    }
    const getGenerationAddFunc = (val: string) => {
        // @ts-ignore
        dispatch(getModel(val))
        console.log(val)
    }
    const getBodyAddFunc = (val: string) => {
        // @ts-ignore
        dispatch(getGenerations(val))
        console.log(val)
    }
    const getEngineAddFunc = (val: string) => {
        // @ts-ignore
        dispatch(getEngine(val))
        console.log(val)
    }

    const handleSubmit = (e: any) => {
        e.preventDefault()
    }
    return (
        <div className={styles.addProduct}>
            <div className={`${styles.container} container`}>
                <h2 className="title">Изменить Иерархию Товаров</h2>
                <form onSubmit={handleSubmit}>
                    <Row className="mb-3">
                        <Col md={4}>
                            <Choose name="cars" disabled={step < 1} step={step} setStep={setStep} data={cars} getNext={getModelAddFunc}/>
                        </Col>
                        <Col md={4}>
                            <Choose name="models" disabled={step < 2} step={step} setStep={setStep} data={models} getNext={getGenerationAddFunc}/>
                        </Col>
                        <Col md={4}>
                            <Choose name="generation" disabled={step < 3} step={step} setStep={setStep} data={generation} getNext={getBodyAddFunc}/>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={4}>
                            <Choose name="body" disabled={step < 4} step={step} setStep={setStep} data={body} getNext={getEngineAddFunc}/>
                        </Col>
                        <Col md={4}>
                            <Choose name="engine" disabled={step < 5} step={step} setStep={setStep} data={engine}/>
                        </Col>
                        <Col md={4}>
                            <Button type="submit">Добавить</Button>
                        </Col>
                    </Row>
                </form>
            </div>
        </div>
    );
};

export default AddProduct;
